module.exports = __webpack_public_path__ + "static/media/face-recognition.967c288e.svg";